class Modal {
  constructor(modal) {
    this.modal = modal;
    this.id = this.modal.id;
    this.modalBody = this.modal.querySelector('.modal__body');
    this.openers = document.querySelectorAll(`.js-modal-open[data-modal-id="${this.id}"]`);
    this.closers = this.modal.querySelectorAll('.js-modal-close');
    this.modalBg = (document.querySelector('.modal-bg')) ? document.querySelector('.modal-bg') : '';
    this.form = this.modal.querySelector('.form');

    this.populate();
    this.watch();
  }

  watch() {
    if (!this.modal.classList.contains('modal--static') && this.modalBg) {
      this.modalBg.addEventListener('click', (event) => {
        this.close(event);
      });
    }

    if (this.openers) {
      const root = this;

      for (let a = 0; a < this.openers.length; a += 1) {
        this.openers[a].addEventListener('click', (event) => {
          if (this.openers[a].getAttribute('data-submit') === null) {
            event.preventDefault();
          } else if (!event.target.closest('form').checkValidity()) {
            return false;
          }

          // if (root.form) {
          //     $(root.form).validate().resetForm();
          // }

          const content = this.openers[a].getAttribute('data-modal-content');
          if (content) {
            this.populate(content);
          }

          if (this.openers[a].classList.contains('js-modal-close')) {
            // Wait for close animation, otherwise we won't have a background
            setTimeout(() => {
              root.open();
            }, 400);
          } else {
            root.open();
          }

          return true;
        });
      }
    }

    if (this.closers) {
      for (let b = 0; b < this.closers.length; b += 1) {
        this.closers[b].addEventListener('click', (event) => {
            this.close(event);

            if (this.closers[b].classList.contains('js-modal-tohome'))
            {
                window.location.href = '/';
            }
        });
      }
    }
  }

  populate(content) {
    // Loop over each key/value pair in json data
    if (content) {
      this.data = JSON.parse(content);

      Object.entries(this.data).forEach(([key, value]) => {
        // Get corresponding field in modal
        const fields = this.modal.querySelectorAll(`.js-modal-${key}`);

        // Fill field with data value
        for (let a = 0; a < fields.length; a += 1) {
          if (typeof value === 'object') {
            for (let b = 0; b < value.length; b += 1) {
              const template = fields[a].parentNode.appendChild(fields[a].cloneNode(true));

              Object.entries(value[b]).forEach(([subkey, subvalue]) => {
                const subfield = template.querySelector(`.js-modal-${subkey}`);

                if (subfield.tagName === 'INPUT') {
                  if (subfield.value !== subvalue) {
                    subfield.value = subvalue;
                  }
                } else if (subfield.innterHTML !== subvalue) {
                  subfield.innerHTML = subvalue;
                }
              });
            }

            fields[a].style.display = 'none';
          } else if (fields[a].tagName === 'INPUT') {
            if (fields[a].value !== value) {
              fields[a].value = value;
            }
          } else if (fields[a].tagName === 'IFRAME') {
            if (fields[a].src !== value) {
              fields[a].src = value;
            }
          } else if (fields[a].innerHTML !== value) {
            fields[a].innerHTML = value;
          }
        }
      });
        
    }
  }

  open(force) {
    const tl = new TimelineLite();

    // Defaults
    tl.timeScale(3);
    TweenLite.defaultEase = Quart.easeOut;

    if (this.modal.classList.contains('modal--overflow')) {
      this.constructor.switchOverflow(this.modal, false);
    } else {
      this.constructor.switchOverflow(this.modal, true);
    }

    if (this.modal.classList.contains('modal--shoppinglist')) {
      document.body.classList.add('cart-open');
      document.body.classList.add('no-scroll');
    }

    // Create modal background
    if (document.querySelector('.modal-bg')) {
      this.modalBg = document.querySelector('.modal-bg');
    } else {
      this.modalBg = document.body.appendChild(document.createElement('div'));
      if (!this.modal.classList.contains('modal--static')) {
        this.modalBg.classList.add('modal-bg');
      } else {
        this.modalBg.classList.add('modal-bg--static');
      }
    }

    if (!this.modal.classList.contains('modal--static')) {
      this.modalBg.addEventListener('click', (event) => {
        this.close(event);
      });
    }

    // Animate
    if (this.modal.classList.toString().indexOf('modal--instructions2d') > -1) {

        tl.set(this.modal, { display: 'block' })
            .set(this.modalBg, { display: 'block' })
            .to(this.modal, 1, { autoAlpha: 1})
            .to(this.modalBg, 1, { autoAlpha: 1, onComplete: this.showContent() }, '-=.8');

    } else if (this.modal.classList.toString().indexOf('modal--bottom') > -1) {
      tl.set(this.modal, { display: 'block' })
        .set(this.modalBg, { display: 'block' })
        .to(this.modal, 1, {
          autoAlpha: 1,
            y: this.modal.classList.contains('modal--small') || this.modal.classList.contains('modal--ar') ? '-50%' : '0%',
            x: this.modal.classList.contains('modal--small') || this.modal.classList.contains('modal--ar') ? '-50%' : '',
        })
        .to(this.modalBg, 0.5, { ease: Linear.easeOut, autoAlpha: 1, onComplete: this.showContent() }, 0);
    } else if (this.modal.classList.toString().indexOf('modal--shoppinglist') > -1) {
      tl.set(this.modal, { display: 'flex' })
        .set(this.modalBg, { display: 'block' })
        .to(this.modal, 2, { ease: Power3.easeOut, autoAlpha: 1, x: '0%' })
        .to(this.modalBg, 1, { autoAlpha: 1 }, '-=1.8');
    } else if (force === true && this.modal.classList.toString().indexOf('modal--overviewfilter') >= -1)
    {
        tl.set(this.modal, { autoAlpha: 1, x: '0%' })
          .set(this.modalBg, { autoAlpha: 1 });

        this.modal.style.display = 'block';
        this.modalBg.style.display = 'block';
        this.showContent();
    }
    else {
      tl.set(this.modal, { display: 'block' })
        .set(this.modalBg, { display: 'block' })
        .to(this.modal, 1, { autoAlpha: 1, x: '0%' })
        .to(this.modalBg, 1, { autoAlpha: 1, onComplete: this.showContent() }, '-=.8');
    }
  }

close(event) {
    if (event) {
        event.preventDefault();
    }

    var modalsCount = 0;

    var aOpenModals = document.querySelectorAll('.js-modal');

    for (let i = 0; i < aOpenModals.length; i += 1) {
        //console.log(aOpenModals[i].style.opacity);
        if (aOpenModals[i].style.opacity === '1') {
            modalsCount += 1;
        }
    }

    const tl = new TimelineLite();

    const destroyModalBg = () => {
      this.modalBg.remove();
      website.body.style.overflow = '';
    };

    tl.timeScale(3);
    TweenLite.defaultEase = Quart.easeOut;

    if (this.modal.classList.contains('modal--shoppinglist')) {
      document.body.classList.remove('cart-open');
      document.body.classList.remove('no-scroll');
    }

    if (this.modal.classList.toString().indexOf('modal--instructions2d') > -1) {
        tl.to(this.modalBg, 1, { autoAlpha: 0 }, '-=1')
            .to(this.modal, 1, { autoAlpha: 0, y: '100%' }, '-=1')
            .set(this.modalBg, { display: 'none', onComplete: destroyModalBg });
    } else if (this.modal.classList.toString().indexOf('modal--zoom') > -1 || this.modal.classList.toString().indexOf('modal--full') > -1) {
      tl.to(this.modalBg, 1, { autoAlpha: 0 }, '-=1')
        .to(this.modal, 1, { autoAlpha: 0, y: '100%' }, '-=1')
        .set(this.modalBg, { display: 'none', onComplete: destroyModalBg });
    } else if (this.modal.classList.toString().indexOf('modal--bottom') > -1) {
      tl.to(this.modalBody, 1, { autoAlpha: 0 })
        .to(this.modalBg, 1, { autoAlpha: 0 }, '-=1')
        .to(this.modal, 1, { autoAlpha: 0, y: '100%' }, '-=1')
        .set(this.modalBg, { display: 'none', onComplete: destroyModalBg });
    } else if (this.modal.classList.toString().indexOf('modal--shoppinglist') > -1) {
      tl.to(this.modal, 1, { autoAlpha: 0, x: '100%' }, '')
        .to(this.modalBg, 1, { autoAlpha: 0 }, '')
        .set(this.modalBg, { display: 'none', onComplete: destroyModalBg });
    } else {
        if (modalsCount > 1) {

            tl.to(this.modalBody, 1, { autoAlpha: 0 })
                .to(this.modal, 1, { autoAlpha: 0, x: '100%' }, '-=1');

        } else {

            tl.to(this.modalBody, 1, { autoAlpha: 0 })
                .to(this.modalBg, 1, { autoAlpha: 0 }, '-=1')
                .to(this.modal, 1, { autoAlpha: 0, x: '100%' }, '-=1')
                .set(this.modalBg, { display: 'none', onComplete: destroyModalBg });
        }
    }

  }

  showContent() {
    if (!this.modalBody) return;

    const tl = new TimelineLite();

    tl.to(this.modalBody, 0.3, { autoAlpha: 1 });
  }

  static switchOverflow(modal, enableModalScroll) {
    if (enableModalScroll) {
      modal.style.overflow = 'visible';
      website.body.style.overflow = 'hidden';
    } else {
      modal.style.overflowX = 'hidden';
      modal.style.overflowY = 'auto';
      website.body.style.overflow = 'hidden';
    }
  }
}

function initModals() {
  const aModals = document.querySelectorAll('.js-modal');

  for (let i = 0; i < aModals.length; i += 1) {
    const modal = new Modal(aModals[i]);
  }
}
